import { LENDER_ID, PLATFORM_NAME, RegexConfig } from "./constants";
import { OpenNewTabTargetType, SCREEN_SIZE } from "@voltmoney/types";
import { Dimensions, Linking, Platform } from "react-native";
import { IconTokens } from "@voltmoney/schema";
export const maskBankAccountNumber = (accountNo) => {
    if (accountNo.length > 4) {
        const showString = accountNo.slice(accountNo.length - 4);
        let maskString = '';
        let index = accountNo.length - 4;
        while (index > 0) {
            maskString += 'X';
            index--;
        }
        return maskString.concat(showString);
    }
    return accountNo;
};
export function sortByMonthDescending(array) {
    if (Platform.OS !== 'web') {
        const months = {
            January: 0, February: 1, March: 2, April: 3, May: 4, June: 5,
            July: 6, August: 7, September: 8, October: 9, November: 10, December: 11
        };
        const sortedArray = array.sort((a, b) => {
            const [monthA, yearA] = a.split('-');
            const [monthB, yearB] = b.split('-');
            const dateA = new Date(Number(yearA), months[monthA]);
            const dateB = new Date(Number(yearB), months[monthB]);
            return dateB.getTime() - dateA.getTime();
        });
        return sortedArray;
    }
    const sortedArray = array.sort((a, b) => {
        const dateA = new Date(`${a}-01`);
        const dateB = new Date(`${b}-01`);
        return dateB.getTime() - dateA.getTime();
    });
    return sortedArray;
}
export const groupByMonth = (arrayOfObjects) => {
    const groupedData = {};
    let sortedGroupedData = [];
    if (arrayOfObjects === undefined || arrayOfObjects === null || arrayOfObjects?.length === 0)
        return sortedGroupedData;
    arrayOfObjects.forEach((obj) => {
        const epochValue = obj.settledOn;
        const dateObj = new Date(epochValue);
        const monthName = dateObj.toLocaleString('en-US', { month: 'long' });
        const yearMonthKey = `${monthName}-${dateObj.getFullYear()}`;
        if (!groupedData[yearMonthKey]) {
            groupedData[yearMonthKey] = [];
        }
        groupedData[yearMonthKey].push(obj);
    });
    Object.keys(groupedData).forEach(attr => {
        if (Array.isArray(groupedData[attr])) {
            groupedData[attr].sort((a, b) => {
                const dateA = new Date(a.settledOn);
                const dateB = new Date(b.settledOn);
                return dateB.getTime() - dateA.getTime();
            });
        }
        else {
            console.error(`Settled trans data is not an array`);
        }
    });
    const sortedMonthArray = sortByMonthDescending(Object.keys(groupedData));
    sortedMonthArray.forEach((itemKey, index) => {
        sortedGroupedData.push({ monthYear: `${itemKey}`, data: groupedData[itemKey] });
    });
    return sortedGroupedData;
};
export const returnDateInString = (epochDate) => {
    const { date, month, year } = convertISODate(epochDate);
    let suffix = 'th';
    if (date === "1" || date === "21" || date === "31") {
        suffix = 'st';
    }
    else if (date === "2" || date === "22") {
        suffix = 'nd';
    }
    else if (date === "3" || date === "23") {
        suffix = 'rd';
    }
    return `${date}${suffix} ${month.slice(0, 3)}, ${year}`;
};
export const returnDateInStringV2 = (epochDate) => {
    const { date, month, year } = convertISODate(epochDate);
    return `${date} ${month} ${year}`;
};
export const returnDate = (epochDate) => {
    const { date, month, year } = convertISODate(epochDate);
    return `${date} ${month}`;
};
export const convertISODate = (timeString) => {
    // timeString = "2023-02-28T10:30:52.119Z";
    const dateObj = new Date(timeString);
    const date = dateObj.toLocaleDateString('en-US', { day: 'numeric' });
    const month = dateObj.toLocaleDateString('en-US', { month: 'long' });
    const year = dateObj.toLocaleDateString('en-US', { year: 'numeric' });
    return { date, month, year };
};
export const getEpochTime = (epochTimestamp) => {
    console.warn("epoachTIme", epochTimestamp);
    const date = new Date(epochTimestamp); // Convert to milliseconds
    const formattedTime = date.toLocaleString('en-IN', {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
    });
    return formattedTime;
};
export const addCommasToNumber = (num) => {
    if (num)
        return num?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ',');
    else {
        return "0";
    }
};
export const addRupeesCommasToNumber = (num) => {
    if (num) {
        let isNegative = num < 0;
        let absNum = Math.abs(num);
        let formattedNum = absNum.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ',');
        return (isNegative ? "-₹" : "₹") + formattedNum;
    }
    else {
        return "₹0";
    }
};
export const isPanValid = (pan) => {
    const panRegex = new RegExp(RegexConfig.PAN);
    return panRegex.test(pan);
};
export const isPhoneNumberValid = (phoneNumber) => {
    const phoneNumberRegex = new RegExp(RegexConfig.NEW_MOBILE);
    return phoneNumberRegex.test(phoneNumber);
};
export const sumObjectValues = (obj) => {
    if (obj) {
        return Object.entries(obj).reduce((sum, [_, value]) => sum + value, 0);
    }
    return 0;
};
export const getScreenType = (screenWidth) => {
    const screenWidthX = screenWidth || Dimensions.get('window').width;
    if (screenWidthX < 576)
        return SCREEN_SIZE.X_SMALL;
    if (screenWidthX < 768)
        return SCREEN_SIZE.SMALL;
    if (screenWidthX < 992)
        return SCREEN_SIZE.MEDIUM;
    if (screenWidthX < 1200)
        return SCREEN_SIZE.LARGE;
    if (screenWidthX >= 1200)
        return SCREEN_SIZE.X_LARGE;
    return SCREEN_SIZE.X_SMALL;
};
export const isFromAndroidWebview = () => {
    const isWebView = navigator?.userAgent?.includes('wv');
    console.warn("IS FROM WEBVIEW", isWebView);
    return Platform.OS === "web" ? isWebView : false;
};
export const getLenderIcon = (lenderId) => {
    if (lenderId) {
        switch (lenderId.toLowerCase()) {
            case LENDER_ID.MIRAE:
                return IconTokens.LENDER_MIRAE;
                break;
            case LENDER_ID.TATA:
                return IconTokens.LENDER_TATA;
                break;
            case LENDER_ID.BAJAJ:
                return IconTokens.BAJAJ_FULL_LOGO_NEW;
                break;
            case LENDER_ID.NUVAMA:
                return IconTokens.LENDER_NUVAMA;
                break;
            case LENDER_ID.DSP:
                return IconTokens.DSP_LOGO;
                break;
            default:
                return IconTokens.BAJAJ_FULL_LOGO_NEW;
                break;
        }
    }
    return IconTokens.BAJAJ_FULL_LOGO_NEW;
};
export const getAutoDebitDate = (date) => {
    let resultDate = '';
    switch (Number.parseInt(date)) {
        case 1:
            resultDate = `${date}st of every month`;
            break;
        case 2:
            resultDate = `${date}nd of every month`;
            break;
        case 3:
            resultDate = `${date}rd of every month`;
            break;
        default:
            resultDate = `${date}th of every month`;
            break;
    }
    return resultDate;
};
export const isWeb = () => {
    return Platform.OS === 'web';
};
export const isAndroid = () => {
    return Platform.OS === 'android';
};
export const isIos = () => {
    return Platform.OS === 'ios';
};
export const isFromiOSBrowser = () => {
    if (Platform.OS === "web") {
        const userAgent = window.navigator.userAgent;
        return userAgent.includes('iPhone');
    }
};
export const isFromAndroidBrowser = () => {
    if (Platform.OS === "web") {
        const userAgent = window.navigator.userAgent;
        return userAgent.includes('Android');
    }
};
export const isInIOSWebView = () => {
    const userAgent = navigator.userAgent;
    // Check if it's an iOS device and if the app is using WebView
    //@ts-ignore
    return /iPhone|iPad|iPod/i.test(userAgent) && !window.navigator.standalone && !/Safari/i.test(userAgent);
};
export const convertToTitleCase = (inputString) => {
    // Split the input string into an array of words
    const words = inputString.split(' ');
    // Initialize an empty array to store the corrected words
    const correctedWords = [];
    // Loop through each word
    for (const word of words) {
        // Convert the word to lowercase, except for the first character
        const correctedWord = word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        // Add the corrected word to the array
        correctedWords.push(correctedWord);
    }
    // Join the corrected words to form the final title-cased string
    const titleCasedString = correctedWords.join(' ');
    return titleCasedString;
};
export const openNewTabDC = (url, targetType = OpenNewTabTargetType.blank, config = {
    width: 600,
    height: 600,
    target: 'Volt Money',
}) => {
    if (Platform.OS === 'web') {
        if (targetType === OpenNewTabTargetType.popup &&
            config &&
            config.width &&
            config.height &&
            config.target) {
            const left = screen.width / 2 - config.width / 2;
            const top = screen.height / 2 - config.height / 2;
            window.open(url, `${config.target}`, `height=${config.height},width=${config.width}. top=${top}, left=${left}`);
        }
        else {
            window.open(url, targetType);
        }
    }
    else {
        Linking.openURL(url);
    }
};
export const getParameters = (url) => {
    if (url) {
        const params = {};
        const paramString = url.split('?')[1];
        console.log('test param string', paramString);
        const queryString = new URLSearchParams(paramString);
        console.log('test query', queryString);
        for (const pair of queryString.entries()) {
            params[pair[0].includes('/') ? pair[0].split('/')[1] : pair[0]] =
                pair[1].includes('/') ? pair[1].split('/')[0] : pair[1];
        }
        return params;
    }
    return {};
};
export const convertEpochToDateWithoutYear = (timeStamp) => {
    const date = new Date(timeStamp * 1000);
    // Define an array of month names
    const monthNames = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ];
    // Extract the day, month, and year from the date
    const day = date.getDate();
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    // Create the formatted date string
    const formattedDate = `${day} ${month}`;
    return formattedDate;
};
export const alphabetsAndDotRegex = /^(?![.\s])[a-zA-Z.\s]*$/;
export const convertEpochToDate = (timeStamp) => {
    const date = new Date(timeStamp * 1000);
    // Define an array of month names
    const monthNames = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ];
    // Extract the day, month, and year from the date
    const day = date.getDate();
    const month = monthNames[date.getMonth()];
    const { year } = convertISODate(timeStamp);
    // Create the formatted date string
    const formattedDate = `${day} ${month} ${year}`;
    return formattedDate;
};
export const convertEpochToDateV2 = (timeStamp) => {
    const date = new Date(timeStamp);
    // Define an array of month names
    const monthNames = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ];
    // Extract the day, month, and year from the date
    const day = date.getDate();
    const month = monthNames[date.getMonth()];
    const { year } = convertISODate(timeStamp);
    // Create the formatted date string
    const formattedDate = `${day} ${month} ${year}`;
    return formattedDate;
};
export function formatEpoch(epoch) {
    const date = new Date(epoch); // Convert to milliseconds
    // Define options for formatting the date
    const dateOptions = {
        day: 'numeric',
        month: 'short',
        timeZone: 'Asia/Kolkata'
    };
    // Define options for formatting the time
    const timeOptions = {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
        timeZone: 'Asia/Kolkata'
    };
    // Format date and time separately
    //@ts-ignore
    const formattedDate = new Intl.DateTimeFormat('en-US', dateOptions).format(date);
    //@ts-ignore
    const formattedTime = new Intl.DateTimeFormat('en-US', timeOptions).format(date);
    // Convert time format from "2:30 PM" to "2:30pm"
    const formattedTimeLowerCase = formattedTime.replace(' AM', 'am').replace(' PM', 'pm');
    // Return the formatted date and time in the desired format
    return `${formattedDate}, ${formattedTimeLowerCase}`;
}
export function formatEpochIntoYear(epoch) {
    // Create a new Date object from the epoch time
    const date = new Date(epoch); // Convert from seconds to milliseconds
    // Define options for formatting the date (excluding time)
    const dateOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    };
    // Format the date part using toLocaleString
    //@ts-ignore
    const formattedDatePart = date.toLocaleString('en-GB', dateOptions);
    // Extract and format the time part separately
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const period = hours >= 12 ? 'PM' : 'AM';
    // Convert hours from 24-hour to 12-hour format and pad with leading zero if necessary
    hours = (hours % 12) || 12; // Convert 0 to 12 for 12-hour clock
    const paddedHours = hours.toString().padStart(2, '0');
    // Combine the date and time parts into the final formatted date string
    const formattedDate = `${formattedDatePart} at ${paddedHours}:${minutes} ${period}`;
    return formattedDate;
}
export const isFromTDLPlatform = () => {
    if (Platform.OS === 'web') {
        const url = window.location.href || '';
        const params = getParameters(url);
        const platformCode = params?.platform || '';
        if (platformCode === PLATFORM_NAME.TDL)
            return true;
        else
            return false;
    }
    return false;
};
export const getDateMonthYearFormat = (epoch) => {
    const date = new Date(epoch);
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = monthNames[date.getMonth()];
    return `${day} ${month} ${year}`;
};
export const convertEpochToCustomFormat = (epochTime) => {
    const months = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    const date = new Date(epochTime); // No need to multiply by 1000 for milliseconds
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month}, ${year}`;
};
export const roundToTwoDecimalPlaces = (num) => {
    const parsedNum = parseFloat(num);
    if (isNaN(parsedNum)) {
        return 0;
    }
    else {
        return parseFloat(parsedNum.toFixed(2));
    }
};
export const getDateMonthYearFromEpochFromMicroseconds = (epochNumber) => {
    if (!epochNumber)
        return ""; // Handle undefined case
    const newDateToPick = new Date(epochNumber * 1000); // JavaScript automatically adjusts to local timezone
    const displayDate = newDateToPick.getDate().toString().padStart(2, '0');
    const dateName = `${displayDate}${addSuffix(Number(displayDate))}`;
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];
    const getMonthName = newDateToPick.getMonth();
    const currentYear = newDateToPick.getFullYear();
    return `${dateName} ${monthNames[getMonthName]}, ${currentYear}`;
};
export const addSuffix = (day) => {
    if (day >= 11 && day <= 13) {
        return 'th';
    }
    switch (day % 10) {
        case 1:
            return 'st';
        case 2:
            return 'nd';
        case 3:
            return 'rd';
        default:
            return 'th';
    }
};
export const showRegisterCustomer = () => {
    const userFromLocalStorage = JSON.parse(localStorage.getItem('user_context'));
    if (userFromLocalStorage && userFromLocalStorage != 'undefined') {
        const partnerDashboardConfig = userFromLocalStorage?.linkedPlatformAccounts[0]?.platformPartnerDashboardConfig;
        if (partnerDashboardConfig?.showRegisterCustomer == true) {
            return true;
        }
        else if (partnerDashboardConfig?.showRegisterCustomer == false) {
            return false;
        }
    }
    return true;
};
export const showRMDetails = () => {
    const userFromLocalStorage = JSON.parse(localStorage.getItem('user_context'));
    if (userFromLocalStorage && userFromLocalStorage != 'undefined') {
        const partnerDashboardConfig = userFromLocalStorage?.linkedPlatformAccounts[0]?.platformPartnerDashboardConfig;
        if (partnerDashboardConfig?.showRMContact == true) {
            return true;
        }
        else if (partnerDashboardConfig?.showRMContact == false) {
            return false;
        }
    }
    return true;
};
export const showShareLink = () => {
    const userFromLocalStorage = JSON.parse(localStorage.getItem('user_context'));
    if (userFromLocalStorage && userFromLocalStorage != 'undefined') {
        const partnerDashboardConfig = userFromLocalStorage?.linkedPlatformAccounts[0]?.platformPartnerDashboardConfig;
        if (partnerDashboardConfig?.showShareLink == true) {
            return true;
        }
        else if (partnerDashboardConfig?.showShareLink == false) {
            return false;
        }
    }
    return true;
};
export const showPlj = () => {
    const userFromLocalStorage = JSON.parse(localStorage.getItem('user_context'));
    if (userFromLocalStorage && userFromLocalStorage != 'undefined') {
        const partnerDashboardConfig = userFromLocalStorage?.linkedPlatformAccounts[0]?.platformPartnerDashboardConfig;
        if (partnerDashboardConfig?.showPlj == true) {
            return true;
        }
        else if (partnerDashboardConfig?.showPlj == false) {
            return false;
        }
    }
    return true;
};
export const showInterestCalculator = () => {
    const userFromLocalStorage = JSON.parse(localStorage.getItem('user_context'));
    if (userFromLocalStorage && userFromLocalStorage != 'undefined') {
        const partnerDashboardConfig = userFromLocalStorage?.linkedPlatformAccounts[0]?.platformPartnerDashboardConfig;
        if (partnerDashboardConfig?.showInterestCalculator == true) {
            return true;
        }
        else if (partnerDashboardConfig?.showInterestCalculator == false) {
            return false;
        }
    }
    return true;
};
